import { Injectable } from '@angular/core';
import { IIqFeatureFlagService } from './iq-feature-flag.service';
import { z } from 'zod';

const MockFlagValue = z.object({
    variables: z.map(z.string(), z.unknown()),
    enabled: z.boolean(),
    variation: z.string(),
});

const MockFlagSchema = z.map(z.string(), MockFlagValue);

type MockFlag = z.infer<typeof MockFlagSchema>;
type MockFlagValue = z.infer<typeof MockFlagValue>;

@Injectable({
    providedIn: 'root',
})
export class SbIqFeatureFlagService implements IIqFeatureFlagService {
    private _flagMap: MockFlag = new Map();

    constructor() {}

    async getVariable(flag: string, variable: string): Promise<unknown> {
        return Promise.resolve(
            this._flagMap.get(flag)?.variables?.get(variable) ?? null,
        );
    }

    setFlag(
        flag: string,
        variable: string,
        value: unknown,
    ): SbIqFeatureFlagService {
        if (!this._flagMap.has(flag)) {
            this._flagMap.set(flag, this.emptyFlagSettings());
        }

        this._flagMap.get(flag)?.variables?.set(variable, value);

        return this;
    }

    private emptyFlagSettings(): MockFlagValue {
        return {
            variables: new Map<string, unknown>(),
            enabled: true,
            variation: 'On',
        };
    }
}
